/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowFatLineUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M231.39062,123.06152A8,8,0,0,1,224,128H184v56a8.00039,8.00039,0,0,1-8,8H80a8.00039,8.00039,0,0,1-8-8V128H32a8.00065,8.00065,0,0,1-5.65723-13.65723l96-96a8.003,8.003,0,0,1,11.31446,0l96,96A8.002,8.002,0,0,1,231.39062,123.06152ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default ArrowFatLineUp;
